export const enviarcheckin = {
    text1: "Wyślij check-in",
    text2: "Wyślij gościom link, aby mogli dokonać check-inu przed przyjazdem do obiektu.",
    text3: "Wybierz zakwaterowanie *",
    text4: "Wpisz imię i nazwisko",
    text5: "Imię i nazwisko gościa *",
    text6: "Numer telefonu gościa *",
    text7: "E-mail",
    text8: "E-mail gościa *",
    text9: "Wyślij",
    text09: "Zaplanuj",
    text10: "Wysyłanie check-inu, proszę czekać",
    text11: "Aby przypisać check-in, należy wybrać zakwaterowanie",
    text12: "Pole imienia i nazwiska jest wymagane",
    text13: "Pole telefonu jest wymagane",
    text14: "Adres e-mail jest wymagany",
    text15: "Już prawie gotowe",
    text16: "Dzień dobry, ",
    text17: "! Tu ",
    text18: ". Wysyłamy tę wiadomość, aby można było dokonać check-inu jeszcze przed przyjazdem do naszego obiektu, a dzięki temu uniknąć oczekiwania w recepcji, a przede wszystkim zbędnego zużycia papieru. \n\nDla bardziej zielonej planety!",
    text19: "Dzień dobry, ",
    text20: "! Tu ",
    text21: ". Wysyłamy tę wiadomość, aby można było dokonać check-inu jeszcze przed przyjazdem do naszego obiektu, a dzięki temu uniknąć oczekiwania w recepcji, a przede wszystkim zbędnego zużycia papieru. <br> <br> Dla bardziej zielonej planety!",
    text22: "Check-in został wysłany",
    text23: "Wczytywanie ...",

    // Poprawki
    p1: "Wyślij link do check-inu",
    p2: "Utwórz rezerwację",
    p3: "Informacje o rezerwacji",
    p4: "Imię i nazwisko gościa odpowiedzialnego",
    p5: "Data check-inu",
    p6: "Data check-outu",
    p7: "Liczba gości",
    p8: "Wybierz pokój",
    p9: "Nie określono",
    p10: "Wybierz numer pokoju",
    p11: "Check-in online",
    p12: "Cena rezerwacji",
    p13: "Utwórz rezerwację",
    p14:`Teraz zaproś gościa do wykonania check-inu.`,
    p15:`Dodatkowa opłata`,

    p16:`Wskaż pokój`,
    p17:`Po wybraniu pokoju wyślemy przypisane do niego klucze`,
    p18:`Wybierz pokój`,
    p19:`Brak wyników. Spróbuj innego hasła.`,
    p20:`Brak dostępnych pokoi.`,
    p21:`Naciśnij enter, aby wybrać`,
    p22:`Wybrano`,
    p23:`Naciśnij enter, aby usunąć`,
    p24:`Brak dostępnych opcji`,
    p25: `Rezerwacja została utworzona.`,
    p26: `Rezerwacja została pomyślnie zakończona. Można wrócić na stronę główną.`,
    p27: `Zaproszenie zostało wysłane.`,
    p28: `OK`,
};
